import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { HOME_CONTENT_MOCK } from '../../data/home-content.mock';
import type { HomeAliadosContent, HomeAliadosLogo } from '../../models/home-aliados-content.model';
import { HomeAliadosService } from '../../services/home-aliados.service';
import { splitAliadosLogosIntoRows } from '../../utils/home-aliados-banner.mapper';
import { prepareAliadosTitleHtml } from '../../utils/home-aliados-html.util';

@Component({
  selector: 'app-home-aliados',
  templateUrl: './home-aliados.component.html',
  styleUrls: ['./home-aliados.component.scss'],
  standalone: false,
})
export class HomeAliadosComponent implements OnInit {
  content: HomeAliadosContent = buildInitialContent();
  titleSafe: SafeHtml = '';
  /** Primera mitad alfabética (sin reverse). */
  rowA: HomeAliadosLogo[] = [];
  /** Segunda mitad alfabética (sin reverse). */
  rowB: HomeAliadosLogo[] = [];

  constructor(
    private readonly homeAliadosService: HomeAliadosService,
    private readonly sanitizer: DomSanitizer
  ) {
    this.applyContent(this.content);
  }

  ngOnInit(): void {
    this.homeAliadosService.loadContent().subscribe((content) => {
      this.applyContent(content);
    });
  }

  private applyContent(content: HomeAliadosContent): void {
    this.content = content;
    this.titleSafe = this.sanitizer.bypassSecurityTrustHtml(content.titleHtml); // NOSONAR — sanitize en mapper
    const { rowA, rowB } = splitAliadosLogosIntoRows(content.logos);
    this.rowA = rowA;
    this.rowB = rowB;
  }
}

function buildInitialContent(): HomeAliadosContent {
  const mock = HOME_CONTENT_MOCK.aliados;
  return {
    eyebrow: mock.eyebrow,
    titleHtml: prepareAliadosTitleHtml(mock.titleHtml),
    description: mock.description,
    joinPrompt: mock.joinPrompt,
    uniteLabel: mock.uniteLabel,
    uniteUrl: mock.uniteUrl,
    logos: [],
  };
}
